import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBag: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBag"><Path d="M2.50391 20.5H21.5017V7.5H2.50391V20.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M21 12.5H3" stroke="currentColor" strokeLinecap="square"/><Path d="M12 12.5V15" stroke="currentColor" strokeLinecap="square"/><Path d="M8 7.5V3.5H16V7.5" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBag;
